import { combineReducers } from 'redux';
import Header from './header/Reducer';
import UiReducer from '../reducer/ui/UiReducer';
import Organization from '../reducer/organization/Organization';
import AgentConfiguration from '../reducer/agentConfiguration/AgentConfiguration';
import Dashboard from '../reducer/dashboard/Reducer';
import Team from '../reducer/team/Reducer';
import ExecuteSummary from './team/ExecuteSummary';
import DeepDive from '../reducer/team/DeepDive';
import Report from './report/Reducer';
import applicationConfig from './applicationConfig/Reducer';
import ScreenShotConfig from '../reducer/screenShotConfig/ScreenShotConfig';
import SystemResources from './team/SystemResources';
import Payment from './payment/Reducer';
import restrictedappusage from './restrictedappusage/Reducer';
import { connectRouter } from 'connected-react-router/immutable';
import { createBrowserHistory } from 'history';
import offlineTime from '../reducer/offlineTime/OfflineTime'
import license from '../reducer/license/Reducer'
import timeLine from '../reducer/timeLine/Reducer'
import SMTP from './smtp/Reducer'
import Leave from './leave/Reducer'
import worktime from './worktime/Reducer'
import DashboardDelegation from './dashboardDelegation/Reducer'
import AbsenceReport from './team/AbsenceReport'
import Trakzolite from './trakzoLite/TrakzoLite'
import MailSchedule from './mailSchedule/MailSchedule'
import GenericHoliday from './genericHoliday/GenericHoliday'
import CapacityPlans from './CapacityPlan/Reducer'
import EmployeeDetails from './employeeDetails/EmployeeDetails';
import Attendance from './attendance/Attendance';
import assertReport from "./assetReports/Reducer";
import softwareDetails from "./softwaredetails/Reducer";
import CapacityPlansDashboard from './capacityPlanDashboard/capacityPlanDashboard';
export const history = createBrowserHistory();

export default combineReducers({
    header: Header,
    ui: UiReducer,
    dashboard: Dashboard,
    userdetail: Team,
    executeSummary: ExecuteSummary,
    deepDive: DeepDive,
    SystemResources: SystemResources,
    report: Report,
    applicationConfig: applicationConfig,
    router: connectRouter(history),
    Organization: Organization,
    AgentConfiguration: AgentConfiguration,
    ScreenShotConfig: ScreenShotConfig,
    Payment: Payment,
    OfflineTime: offlineTime,
    restrictedappusage: restrictedappusage,
    SMTP: SMTP,
    license: license,
    timeLine: timeLine,
    leave: Leave,
    worktime: worktime,
    dashboardDelegation: DashboardDelegation,
    absenceReport: AbsenceReport,
    genericHoliday: GenericHoliday,
    trakzoLite: Trakzolite,
    mailSchedule: MailSchedule,
    CapacityPlans: CapacityPlans,
    employeeDetails: EmployeeDetails,
    attendance: Attendance,
    assertReport: assertReport,
    softwareDetails:softwareDetails,
    capacityPlansDashboard: CapacityPlansDashboard
})
